import React, { useEffect } from 'react'
import './App.css'
import { Navigate, useNavigate, BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom'
import Login from './components/login'
import SignUp from './components/signup'
// imSport Home from './components/home'
import Activate from './components/activate'
import Companies from './components/companies'
import CreateCompany from './components/create-company'
import Groups from './components/groups'
import CreateGroup from './components/create-group'
import Accounts from './components/accounts'
import Group from './components/group'
import CreateTerminals from './components/create-terminals'
import CreateAccounts from './components/create-accounts'
import './loader.js'
import { isDev } from './components/utils/helper'
import { isMobile } from "react-device-detect";


function App() {
  let accessToken = sessionStorage.getItem("accessToken");
  let count = 0;
  let _isDev = isDev();
  // const navigate = useNavigate();

  useEffect(() => {
    count = count + 1;
    console.log("On page load: " + count);
    if (count === 1 && _isDev) {
      return;
    }

    if (isMobile) {
      if (!accessToken) {
        let mainBox = document.getElementById("main-box-sign-in");
        mainBox.className = "auth-inner-mobile";
      } else {
        let mainBox = document.getElementById("main-box-signed-in");
        mainBox.className = "auth-inner-mobile";
      }
    }
  }, [count]);

  function signOut() {
    sessionStorage.removeItem("accessToken");
    let navigate = useNavigate();
    window.location.href = '/sign-in';
    // navigate(0);
  }

  // function signOutCancel() {
  //   let confirmationDialog = document.getElementById("sign-out-confirmation-dialog");
  //   confirmationDialog.remove();
  // }

  // async function onSignoutClick() {
  //   console.log("onSignoutClick");
  //   // let optionsConfig = [
  //   //   { text: 'Sign out', value: true },
  //   //   { text: 'Back', value: false }
  //   // ]
  //   // const answer = await notifier.showDialog('Sign out', optionsConfig);
  //   let answer = windows.confirm('Sign out');
  //   if (answer) {
  //     signOutConfirm();
  //   } else {
  //     signOutCancel();
  //   }
  //   // confirmation("sign-out-confirmation-dialog", "Sign out", () => {}, "Back", () => {});
  // }

  if (!accessToken) {
    return (
      <Router>
        <div className="App">
          <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="navbar-sign-in">
            <div className="container">
              <Link className="navbar-brand" to={'/sign-in'}>The Payment Company&nbsp;</Link>

              {/* <div className="collapse navbar-collapse" id="navbarTogglerDemo02"> */}
              <div className="navbar-collapse" id="navbar-elements-sign-in">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item"><Link className="nav-link" to={'/sign-in'}>Login</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/sign-up'}>Sign up</Link></li>
                </ul>
              </div>
            </div>
          </nav>
          <div className="auth-wrapper">
            <div className="auth-inner" id="main-box-sign-in">
              <Routes>
                <Route exact path="/" element={<Login />} />
                <Route path="/sign-in" element={<Login />} />
                <Route path="/sign-up" element={<SignUp />} />
                <Route path="/activate" element={<Activate />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/create-company" element={<CreateCompany />} />
                <Route path="/create-company/*" element={<CreateCompany />} />
                <Route path="/companies/:companyId/groups/:groupId/create-terminals" element={<CreateTerminals />} />
                <Route path="/companies/:companyId/groups/:groupId/create-accounts" element={<CreateAccounts />} />
                <Route path="/groups" element={<Groups />} />
                <Route path="/create-group/*" element={<CreateGroup />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/group/*" element={<Group />} />
                <Route path="/group" element={<Group />} />
                <Route path="*" element={<Navigate to='/sign-in' />} />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    )
  } else {
    return (
      <Router>
        <div className="App">
          <nav className="navbar navbar-expand-lg navbar-light fixed-top" id="navbar-sign-in">
            <div className="container">
              <Link className="navbar-brand" to={'/companies'}>The Payment Company</Link>
              <div className="new-line">
                <label>&nbsp;</label>
              </div>
              <div className="navbar-collapse" id="navbar-elements-signed-in">
                <ul className="navbar-nav ml-auto">
                  <li className="nav-item"><Link className="nav-link" to={'/companies'}>Companies</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/groups'}>Groups</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/accounts'}>Accounts</Link></li>
                  <li className="nav-item"><Link className="nav-link" to={'/group'}>Group</Link></li>
                  <li className="nav-item"><Link className="nav-link" onClick={() => { signOut(); }}>Sign out</Link></li>
                </ul>
              </div>
            </div>
          </nav>
          <div className="auth-wrapper">
            <div className="auth-inner" id="main-box-signed-in">
              <Routes>
                <Route exact path="/" element={<Companies />} />
                <Route path="/companies" element={<Companies />} />
                <Route path="/create-company" element={<CreateCompany />} />
                <Route path="/companies/:companyId/groups" element={<Groups />} />
                <Route path="/companies/:companyId/groups/:groupId" element={<Group />} />
                <Route path="/groups" element={<Groups />} />
                <Route path="/group" element={<Group />} />
                <Route path="/create-group/*" element={<CreateGroup />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/companies/*" element={<Companies />} />
                <Route path="/companies/:companyId/groups/:groupId/create-terminals" element={<CreateTerminals />} />
                <Route path="/companies/:companyId/groups/:groupId/create-accounts" element={<CreateAccounts />} />
                <Route path="*" element={<Navigate to='/companies' />} />
              </Routes>
            </div>
          </div>
        </div>
      </Router>
    )
  }
}
export default App